import type { ParsedSegment } from './types';

/**
 * Normalize space character to non-breaking space character.
 * This is needed in order to preserve the line height of empty strings (with 1 space character).
 *
 * @param segments - parsed segments
 * @returns parsed segments with normalized space characters
 */
export const normalizeSpaceCharacter = (
  segments: Array<ParsedSegment>,
): Array<ParsedSegment> =>
  segments.map(segment => {
    if (segment.data === ' ') {
      return { ...segment, data: '\u00A0' };
    }
    return segment;
  });
